import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../styles/Footer.module.css';
import tiktokIcon from '../assets/icons/tiktok-icon.webp';
import facebookIcon from '../assets/icons/facebook-icon.webp';
import instagramIcon from '../assets/icons/instagram-icon.webp';
import twitterIcon from '../assets/icons/twitter-icon.webp';
import telegramIcon from '../assets/icons/telegram-icon.webp';
import comparisonsList from '../data/comparisons.json';
import { categories } from '../data/catalog';

const Footer = () => {
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleAlertsClick = (event) => {
        if (location.pathname !== '/' || location.hash !== '#alertas') return;
        const section = document.getElementById('alertas');
        if (!section) return;
        event.preventDefault();
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleNewsletterSubmit = async (event) => {
        event.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            if (!response.ok || !data.ok) throw new Error(data.error || 'No se pudo suscribir');
            toast.success('Listo, cada viernes te llegan las 10 mejores gangas.');
            setEmail('');
        } catch (error) {
            toast.error('Revisa el correo e intentalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.footerGrid}>
                <div className={styles.brand}>
                    <h2>Esganga</h2>
                    <p>
                        Gangas, codigos descuento y ofertas seleccionadas. Enlaces de afiliado
                        {' '}-- <Link to="/aviso-legal">mas info</Link>.
                    </p>
                    <form className={styles.newsletterForm} onSubmit={handleNewsletterSubmit}>
                        <label htmlFor="footer-newsletter-email">Las 10 mejores gangas de la semana, cada viernes</label>
                        <div className={styles.newsletterRow}>
                            <input
                                id="footer-newsletter-email"
                                type="email"
                                required
                                placeholder="tucorreo@ejemplo.com"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                            />
                            <button type="submit" disabled={loading}>
                                {loading ? 'Enviando...' : 'Suscribirme'}
                            </button>
                        </div>
                    </form>
                </div>
                <div className={styles.linkGroup}>
                    <h3>Explora</h3>
                    <nav className={styles.links}>
                        <Link to="/#chollos">Gangas de hoy</Link>
                        <Link to="/cupones">Cupones</Link>
                        <Link to="/buscar">Buscar ofertas</Link>
                        <Link to="/#tiendas">Tiendas</Link>
                        <Link to="/comparar">Comparar</Link>
                        <Link to="/buscador-inteligente">¿Qué necesitas?</Link>
                        <Link to="/informe-precios">Informe de precios</Link>
                        <Link to="/juegos">Juegos</Link>
                        <Link to="/#alertas" onClick={handleAlertsClick}>Alertas</Link>
                        <Link to="/amazon">Amazon</Link>
                        <Link to="/mejores/tecnologia">Mejores ofertas</Link>
                        <Link to="/comparativas/robot-aspirador-vs-aspiradora-escoba">Comparativas</Link>
                    </nav>
                </div>
                <div className={styles.linkGroup}>
                    <h3>Ayuda y legal</h3>
                    <nav className={styles.links}>
                        <Link to="/quienes-somos">Quiénes somos</Link>
                        <Link to="/contact">Contacto</Link>
                        <Link to="/aviso-legal">Aviso legal</Link>
                        <Link to="/politica-privacidad">Política de privacidad</Link>
                        <Link to="/politica-cookies">Política de cookies</Link>
                    </nav>
                </div>
                <div className={styles.contactCol}>
                    <h3>Síguenos</h3>
                    <a href="mailto:info@esganga.es">info@esganga.es</a>
                    <div className={styles['social-icons']}>
                        <a href="https://www.tiktok.com/@esganga.es/" target="_blank" rel="noopener noreferrer" aria-label="TikTok de Esganga, abre en una pestaña nueva"><img src={tiktokIcon} alt=""/></a>
                        <a href="https://www.facebook.com/www.esganga.es" target="_blank" rel="noopener noreferrer" aria-label="Facebook de Esganga, abre en una pestaña nueva"><img src={facebookIcon} alt=""/></a>
                        <a href="https://www.instagram.com/esganga_es/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Esganga, abre en una pestaña nueva"><img src={instagramIcon} alt=""/></a>
                        <a href="https://twitter.com/esganga_es" target="_blank" rel="noopener noreferrer" aria-label="Twitter de Esganga, abre en una pestaña nueva"><img src={twitterIcon} alt=""/></a>
                        <a href="https://t.me/esganga" target="_blank" rel="noopener noreferrer" aria-label="Telegram de Esganga, abre en una pestaña nueva"><img src={telegramIcon} alt=""/></a>
                    </div>
                </div>
            </div>
            <nav className={styles.hubLinks} aria-label="Rankings y comparativas">
                <div className={styles.hubGroup}>
                    <h3>Rankings por categoría</h3>
                    <div className={styles.hubChips}>
                        {categories.map((category) => (
                            <Link key={category.slug} to={`/mejores/${category.slug}`}>{category.name}</Link>
                        ))}
                    </div>
                </div>
                <div className={styles.hubGroup}>
                    <h3>Comparativas de productos</h3>
                    <div className={styles.hubChips}>
                        {comparisonsList.map((item) => (
                            <Link key={item.slug} to={`/comparativas/${item.slug}`}>{item.title.split(':')[0]}</Link>
                        ))}
                    </div>
                </div>
            </nav>
            <p className={styles.copy}>&copy; 2026 Esganga. Todos los derechos reservados.</p>
        </footer>
    );
};

export default Footer;
